import {TDeepPartial} from 'shared/types/generics';
import {ERequestType} from 'shared/types/requests';
import {performRequest} from 'shared/utils';
import {ORG_STRUCTURE_BASE_URL} from 'store/slices/ais-slice/organization-structure/organization-structure-constants';
import {TOrganizationStructureDto} from 'store/slices/ais-slice/organization-structure/organization-structure-types';

export const fetchOrganizationStructureData = () => performRequest<
    TOrganizationStructureDto>({
        url: [
            ORG_STRUCTURE_BASE_URL,
            'getInfo',
        ].join('/'),
        method: ERequestType.GET,
    });

export interface ISaveOrganizationStructureDataRequestArgs {
    data: TDeepPartial<TOrganizationStructureDto>;
}

export const saveOrganizationStructureDataRequest = ({
    data,
}: ISaveOrganizationStructureDataRequestArgs) => performRequest<string>({
    url: [
        ORG_STRUCTURE_BASE_URL,
        'updateAll',
    ].join('/'),
    method: ERequestType.POST,
    data,
});
